import { getDefaultStore, useAtom } from 'jotai';

import { atomWithToggle } from '~shared/jotai/atomWithToggle';

export const reportsShowResponsesAtom = atomWithToggle(false);
export const resultsShowResponsesAtom = atomWithToggle(true);

export const useIsResultsShowResponse = () => useAtom(resultsShowResponsesAtom);

export const useIsReportsShowResponse = () => useAtom(reportsShowResponsesAtom);

export function useShowResponses(isActivityInProgress: boolean) {
  const isResultsShowResponses = useIsResultsShowResponse();
  const isReportsShowResponses = useIsReportsShowResponse();

  return isActivityInProgress ? isResultsShowResponses : isReportsShowResponses;
}

export function resetShowResponses() {
  const store = getDefaultStore();
  store.set(reportsShowResponsesAtom, false);
  store.set(resultsShowResponsesAtom, true);
}

export function useCopyShowResponseToReport() {
  const [, setShowReponse] = useIsReportsShowResponse();
  const [isResultsShowResponses] = useIsResultsShowResponse();
  return () => setShowReponse(isResultsShowResponses);
}
